import { PawPrintIcon } from '@phosphor-icons/react';
import React from 'react';

import { usePetPic } from '../../../hooks/Pet/usePetUtils';
import './Pet.scss';
import { PetProps } from './types';

const Pet: React.FC<PetProps> = ({ pet, setCurrentPet, isCurrent }) => {
  const { petImage } = usePetPic(pet);

  if (!pet) return null;

  return (
    <div
      className={`pet ${isCurrent ? 'pet--current' : ''}`}
      onClick={() => setCurrentPet(pet)}
    >
      <div className="pet__image-container">
        <img src={petImage} alt={pet.nombre || 'Mascota'} className="pet__image" />
        {isCurrent && (
          <div className="pet__badge">
            <PawPrintIcon size={16} weight="fill" />
          </div>
        )}
      </div>
      <div className="pet__name">{pet.nombre}</div>
    </div>
  );
};

export default React.memo(Pet);